
import { RevLink } from '@ds/components/Link'
import { RevModal } from '@ds/components/Modal'
import { IconInfo } from '@ds/icons/IconInfo'
import { mapGetters } from 'vuex'

import { MODAL_NAMES } from '@config/constants'
import { LEGAL_PAGE_NAME } from '@legal/constants'
import { ROUTES } from '@router'

import { COUNTRIES_WITH_REVIEWS_LEGAL_MODAL } from './ReviewsLegalModal.constants'
import translations from './ReviewsLegalModal.translations'

export default {
  components: {
    RevModal,
    IconInfo,
    RevLink,
  },
  computed: {
    ...mapGetters({
      country: 'config/country',
    }),
    translations: () => translations,
    modalName() {
      return `${MODAL_NAMES.REVIEWS.REVIEWS_LEGAL_INFORMATION}_${this.$route.name}`
    },
    pdfLink() {
      return {
        name: ROUTES.CMS.LEGAL_PAGE,
        params: {
          pageName: LEGAL_PAGE_NAME.OTHER,
        },
      }
    },
    hasLegalModal() {
      return COUNTRIES_WITH_REVIEWS_LEGAL_MODAL.includes(this.country)
    },
  },
}
